module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_5012.a9e77a3e.png";